import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const PlanHeadingContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 24px 0px 16px 0px;
`;

export const HeadingText = styled(Text)`
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  background: linear-gradient(269deg, #F16262 -10.35%, #743DDC 106.34%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
